import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { ColDef } from 'ag-grid-community';

export default class RowEditUtils {
  static createFormGroup(colDefs: ColDef[]): UntypedFormGroup {
    const controls = this.createControls(colDefs);
    return new UntypedFormGroup(controls);
  }

  static createControls(colDefs: ColDef[]): {
    [key: string]: AbstractControl;
  } {
    const controls: { [key: string]: AbstractControl } = {};
    colDefs.forEach(colDef => {
      const validators = colDef.cellEditorParams?.validators || [];
      const key = colDef.field;
      if (key) {
        controls[key] = new UntypedFormControl('', validators);
      }
    });
    return controls;
  }
}
